export const COUNTERS_EMPTY_STATE = {
  total: 0,
  inauction: 0,
  inpreparation: 0,
  finished: 0,
  allstages: 0,
  supplier: {},
  manufacturer: {},
  e367: {},
  e223: {},
  e17: {},
  e174: 0,
  ev: 0,
}
